import React, { useState } from "react";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import { handlePostRequest } from "../../services/PostTemplate";
import { InputText } from "primereact/inputtext";
import { useHistory } from "react-router-dom";

const ChangePassword = () => {

    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("");

    const history = useHistory()

    const formik = useFormik({
        initialValues: {
            currPass: "",
            newPass: "",
            newPass1: "",
        },
        validate: (data) => {
            let errors = {};

            if (!data.currPass) {
                errors.currPass = "Current Password is required.";
            }
            if (!data.newPass) {
                errors.newPass = "New Password is required.";
            } else {
                // Password validation rules
                const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
                if (!passwordRegex.test(data.newPass)) {
                    errors.newPass = "Password should be a minimum of 8 characters, have at least 1 uppercase, be alphanumeric, and have 1 special character.";
                }
            }
            if (!data.newPass1) {
                errors.newPass1 = "Confirm Password is required.";
            }
            if (data.newPass && data.newPass1 && data.newPass !== data.newPass1) {
                errors.newPass1 = "Please enter the same password.";
            }
            return errors;
        },
        onSubmit: async (data) => {
            setloading(true);
            setloadingIcon("pi pi-spin pi-spinner");
            delete data["newPass1"];
            await handlePostRequest(data, "zbizgateway/nonFin/changePassword/changePassword");
            setloading(false);
            setloadingIcon("pi pi-save");
            formik.resetForm();
        },
    });
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };
    return (
        <>
            <div className="page_header">
                <div className="Top__Btn" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div className="d_align">
                        <i className="pi pi-arrow-circle-left mr-1" onClick={() => history.goBack()} />
                        <h3 className="mod_heading">Change Password</h3>
                    </div>
                </div>
            </div>

            <div className="card Card__Round">
                <form onSubmit={formik.handleSubmit}>
                    <div className="p-fluid p-formgrid p-grid">
                        <div className="p-field p-col p-col-4">
                            <div className="input_cp">
                                <label>Current Password</label>
                                <InputText id="currPass" name="currPass" value={formik.values.currPass} onChange={formik.handleChange} type="password" className="input_text" />
                                <div style={{ minWidth: "100%" }} className="p-error p-text-left">
                                    {getFormErrorMessage("currPass")}
                                </div>
                            </div>
                        </div>
                        <div className="p-field p-col p-col-4">
                            <div className="input_cp">
                                <label>New Password</label>
                                <InputText id="newPass" name="newPass" value={formik.values.newPass} onChange={formik.handleChange} type="password" className="input_text" />
                                {getFormErrorMessage("newPass")}
                            </div>
                        </div>
                        <div className="p-field p-col p-col-4">
                            <div className="input_cp">
                                <label>Confirm New Password</label>
                                <InputText id="newPass1" name="newPass1" value={formik.values.newPass1} onChange={formik.handleChange} type="password" className="input_text" />
                                {getFormErrorMessage("newPass1")}
                            </div>
                        </div>

                    </div>

                    <div className="GenerateDown__Btn p-mt-4">
                        <Button className="Btn__Transparent" label="Submit" icon={loadingIcon || ""} iconPos="right" disabled={loading} />
                        <Button className="Btn__Dark" label="Cancel" iconPos="right" onClick={() => history.push("/")} type="button" />
                    </div>
                </form>
            </div>

        </>
    );
};

export default ChangePassword;
